module.exports = __webpack_public_path__ + "b8e9c24b00d2780f9d02390b58a20fd4.svg";